import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const campaignInitialDetailsSelect = (state: RootState) =>
  state.whatsAppCampaign.initialDetails;
const campaignContactableDetailsSelect = (state: RootState) =>
  state.whatsAppCampaign.contactableDetails;
const jobLocationsSelect = (state: RootState) =>
  state.whatsAppCampaign.jobLocations;
const faqDetailsSelect = (state: RootState) =>
  state.whatsAppCampaign.faqDetails;
const draftDetailsSelect = (state: RootState) =>
  state.whatsAppCampaign.draftDetails;
const currencySelect = (state: RootState) => state.whatsAppCampaign.currency;
const saveAndContinueResponseSelect = (state: RootState) =>
  state.whatsAppCampaign.saveAndContinueResponse;
const foldersSelect = (state: RootState) => state.whatsAppCampaign.folders;
const fetchFoldersStatusSelect = (state: RootState) =>
  state.whatsAppCampaign.fetchFoldersStatus;

const campaignInitialDetailsSelector = createSelector(
  campaignInitialDetailsSelect,
  (campaignInitialDetails) => {
    return { campaignInitialDetails };
  }
);

const campaignContactableDetailsSelector = createSelector(
  campaignContactableDetailsSelect,
  (campaignContactableDetails) => {
    return { campaignContactableDetails };
  }
);

const jobLocationsSelector = createSelector(
  jobLocationsSelect,
  (jobLocations) => {
    return { jobLocations };
  }
);

const foldersSelector = createSelector(foldersSelect, (folders) => {
  return { folders };
});

const fetchFoldersStatusSelector = createSelector(
  fetchFoldersStatusSelect,
  (fetchFoldersStatus) => {
    return { fetchFoldersStatus };
  }
);

const faqDetailsSelector = createSelector(faqDetailsSelect, (faqDetails) => {
  return { faqDetails };
});

const draftDetailsSelector = createSelector(
  draftDetailsSelect,
  (draftDetails) => {
    return { draftDetails };
  }
);

const currencySelector = createSelector(currencySelect, (currency) => {
  return { currency };
});

const saveAndContinueResponseSelector = createSelector(
  saveAndContinueResponseSelect,
  (saveAndContinueResponse) => {
    return { saveAndContinueResponse };
  }
);

export {
  campaignInitialDetailsSelector,
  campaignContactableDetailsSelector,
  jobLocationsSelector,
  faqDetailsSelector,
  draftDetailsSelector,
  currencySelector,
  saveAndContinueResponseSelector,
  foldersSelector,
  fetchFoldersStatusSelector
};
